var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSynapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.20017H13.5597C13.3002 4.62385 11.7987 2.30465 9.51153 1.02097C9.12577 0.804646 8.63841 0.941926 8.42209 1.32705C8.20577 1.71233 8.34305 2.20001 8.72817 2.41633C10.7464 3.54881 12 5.68833 12 8.00017C12 10.3118 10.7464 12.4514 8.72849 13.5838C8.34321 13.8003 8.20609 14.2877 8.42257 14.6733C8.56913 14.9347 8.84081 15.0819 9.12081 15.0819C9.25329 15.0819 9.38769 15.049 9.51153 14.9794C11.7987 13.6958 13.3002 11.3765 13.5597 8.80017H16V7.20017Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 4.7356C4.07344 4.7356 2.79552 5.78472 2.43808 7.20024H0V8.80024H2.43824C2.79552 10.2159 4.07344 11.2649 5.6 11.2649C7.40304 11.2649 8.86464 9.80296 8.86464 8.00024C8.86464 6.1972 7.40304 4.7356 5.6 4.7356Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynapse);
export default __webpack_public_path__ + "static/media/synapse.20d7bc076b22cde8d7eed80d1c62a8b7.svg";
export { ForwardRef as ReactComponent };